import React from 'react'
import * as styles from './ComicHeader.module.css'

import { StaticImage } from 'gatsby-plugin-image'

export default class Header extends React.Component {
  render() {
    return (
      <aside className={styles.header}>
        <header className={styles.price}>25 ¢</header>
        <section className={styles.name}>
          The Adventures of Vintharas Vol III
        </section>
        <footer className={styles.pixelart}>
          <StaticImage
            src="../../../static/images/pixelart/pixel-art-mooleen-fireball.png"
            alt="Mooleen the JavaScriptmancer"
            title="Behold! Witness My Pawaaaa!!!"
            width={110}
            height={110}
            quality={100}
            loading="eager"
            layout="fixed"
            className={styles.imageContainer}
            imgClassName={styles.image}
            placeholder="none"
          />
        </footer>
      </aside>
    )
  }
}
